import { request } from '@/utils/request/request';

export function getalarmList(query) {
  return request({
    url: 'api/WF/v1/GetWarningList',
    method: 'get',
    params: query,
  });
}
export function getalarmtree() {
  return request({
    url: 'api/WF/v1/Get_WarningTypeTree',
    method: 'get',
  });
}
// /告警详解接口
export function getalarmDetail(query) {
  return request({
    url: 'api/WF/v1/GetWarningDetails',
    method: 'get',
    params: query,
  });
}
// 根据项目获取工单模板列表
export function GetSchemeCodeList(query) {
  return request({
    url: 'api/WF/v1/GetSchemeCodeList',
    method: 'get',
    params: query,
  });
}
// 生成工单
export function createWorkerOrder(query) {
  return request({
    url: 'api/WF/v1/Create',
    method: 'get',
    params: query,
  });
}

// 更新读取状态
export function updatereadStatus(query) {
  return request({
    url: 'api/WF/v1/UpdateWarningReadStatus',
    method: 'get',
    params: query,
  });
}
